// @flow

import * as React from 'react';

import Constants from '../Constants';

export const Ground = (props: { weather: number }) => {
  const classes = ['background-ground'];
  if (props.weather === Constants.WEATHER_SUNNY) {
    classes.push('background-ground-sun');
  } else if (props.weather === Constants.WEATHER_CLOUDY) {
    classes.push('background-ground-cloud');
  } else if (props.weather === Constants.WEATHER_RAINY) {
    classes.push('background-ground-rain');
  }
  return <div className={classes.join(' ')} />;
};
